import React from "react";
import { Form } from "antd";
import { AuthPageContainer } from "pages/containers";
import { ResetPasswordPresentation } from "lib/pages/login/ResetPassword";

export function ResetPassword(props) {
  const ResetPasswordForm = Form.create({ name: "normal_reset_password" })(
    ResetPasswordPresentation
  );
  return (
    <AuthPageContainer pageTitle={props.pageTitle}>
      <ResetPasswordForm {...props} />
    </AuthPageContainer>
  );
}
